// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vSelect from 'vue-select'

import VueTippy, { TippyComponent } from "vue-tippy";
Vue.use(VueTippy);

import { library } from '@fortawesome/fontawesome-svg-core'
import { faSun, faSpinner, faTemperatureHigh, faTemperatureLow, faCloudShowersHeavy,
  faThermometerThreeQuarters } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faSun, faSpinner, faTemperatureHigh, faTemperatureLow, faCloudShowersHeavy,
  faThermometerThreeQuarters);
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js